import MailContext, {withMail} from './context';
import Mail from './mail';
export default Mail;
export { MailContext, withMail };